// extracted by mini-css-extract-plugin
module.exports = {"Container":"Warning_Container__3zBZa","Text":"Warning_Text__1jT2l","FallbackPackage":"Warning_FallbackPackage__24n3e"};